import { extendTailwindMerge } from 'tailwind-merge';

export const twMerge = extendTailwindMerge({
  prefix: 'hola-',
  classGroups: {
    txt: [(className: string) => className.startsWith('hola-txt-')],
  },
});

export const tlwTwMerge = extendTailwindMerge({
  prefix: 'tlw-',
  classGroups: {
    txt: [(className: string) => className.startsWith('tlw-txt')],
  },
});
